import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTeacherForm from "../../forms/CreateOrUpdateTeacherForm";

interface CreateTeacherModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateTeacherModal: React.FC<CreateTeacherModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Register New Teacher"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateTeacherForm loading={loading} error={error} />
  </AppModal>
);

export default CreateTeacherModal;
